import { EMAIL_SUBSCRIPTION_REQUEST, EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_REQUEST } from '../types';

export const subcribeToNewsletter = email => ({ type: EMAIL_SUBSCRIPTION_REQUEST, payload: email });
export const subscribeToEmailWhenSpotOpenUp = payload => ({ type: EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_REQUEST, payload });
